// The fixed sidebar's width. AppLayout offsets the content area by the same value, so keep this
// the single source for both. 112px fits the longest one-line label ("Integrations", Lato 12px
// semibold) inside the item padding; "Fee Schedule", "Payer Rules" and "Contract AI Tool" still
// break onto two lines on purpose.
export const SIDEBAR_WIDTH = "112px";
